import $ from 'jquery'

$(document).ready(function () {
  const confirmationPage = $('#confirmationPage')
  if (confirmationPage.length) {

  }
})
